import request from '@/utils/http';
const apiCrmHost = 'api-lcrm';

// 预测系数-查询-wy
export const getRevenueFactorPage = (data) => {
    return request({
        url: apiCrmHost + '/revenueForecastCoef/page',
        method: 'post',
        data
    });
};
// 预测系数-导出-wy
export const revenueFactorExport = (data) => {
    return request({
        url: apiCrmHost + '/revenueForecastCoef/export',
        method: 'post',
        data
    });
};
// 预测系数-详情-wy
export const getRevenueFactorDetail = (data) => {
    return request({
        url: apiCrmHost + '/revenueForecastCoef/detail',
        method: 'get',
        data
    });
};
// 预测系数-保存-wy
export const revenueFactorSave = (data) => {
    return request({
        url: apiCrmHost + '/revenueForecastCoef/save',
        method: 'post',
        data
    });
};
